import BaseApiService from './BaseApiService';

class SuperAdminService extends BaseApiService {
  async login(username, password) {
    return this.makeRequest('/api/superadmin/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    });
  }

  async getStats() {
    return this.makeRequest('/api/superadmin/stats', {
      method: 'GET',
    });
  }

  async getInstitutions() {
    return this.makeRequest('/api/superadmin/institutions', {
      method: 'GET',
    });
  }

  async registerInstitution(data) {
    return this.makeRequest('/api/superadmin/institutions/register', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async updateInstitution(orgId, data) {
    return this.makeRequest(`/api/superadmin/institutions/${orgId}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async activateInstitution(orgId) {
    return this.makeRequest(`/api/superadmin/institutions/${orgId}/activate`, {
      method: 'PUT',
    });
  }

  async deactivateInstitution(orgId) {
    return this.makeRequest(`/api/superadmin/institutions/${orgId}/deactivate`, {
      method: 'PUT',
    });
  }

  async changePassword(oldPassword, newPassword) {
    return this.makeRequest('/api/superadmin/change-password', {
      method: 'PUT',
      body: JSON.stringify({ oldPassword, newPassword }),
    });
  }

  async resetInstitutionPassword(orgId, newPassword) {
    return this.makeRequest(`/api/superadmin/institutions/${orgId}`, {
      method: 'PUT',
      body: JSON.stringify({ password: newPassword }),
    });
  }

  async updateStorageLimit(orgId, storageQuotaGb, retentionDays) {
    return this.makeRequest(`/api/superadmin/institutions/${orgId}/storage-limit`, {
      method: 'PUT',
      body: JSON.stringify({ storageQuotaGb, retentionDays }),
    });
  }
}

const superAdminService = new SuperAdminService();
export default superAdminService;
